import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { MatRadioModule } from '@angular/material/radio';
import { MAT_RIPPLE_GLOBAL_OPTIONS, MatRippleModule } from '@angular/material/core';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AccessControlDirective } from '@app/core/directives/access-control.directive';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
    declarations: [],
    exports: [
        CommonModule,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatTableModule,
        MatSortModule,
        MatMenuModule,
        MatDialogModule,
        RouterModule,
        MatRippleModule,
        MatRadioModule,
        PageHeaderComponent,
        MatCheckboxModule,
        AccessControlDirective,
        MatChipsModule,
        MatDatepickerModule,
        MomentDateModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatTableModule,
        MatSortModule,
        MatMenuModule,
        MatDialogModule,
        RouterModule,
        MatRippleModule,
        MatRadioModule,
        PageHeaderComponent,
        MatCheckboxModule,
        AccessControlDirective,
        MatChipsModule,
        MatDatepickerModule,
        MomentDateModule
    ],
    providers: [{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } }, provideHttpClient(withInterceptorsFromDi())]
})
export class SharedModule { }
